import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppState } from '@immosky/types';
import {
  selectIsMapVisible,
  setIsMapVisible,
} from '@immosky/object-search-layout';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'app-desktop-map-toggle',
  templateUrl: './desktop-map-toggle.component.html',
  styleUrls: ['./desktop-map-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopMapToggleComponent {
  isVisible$ = this.store.pipe(select(selectIsMapVisible));

  constructor(private store: Store<AppState>) {}

  setMapVisible(isVisible: boolean) {
    this.store.dispatch(
      setIsMapVisible({
        isMapVisible: isVisible,
      })
    );
  }
}
